export default "__VITE_ASSET__DETohh_t__"